import { isEmpty } from 'lodash'

import axiosInstance from 'api/axiosInstance'
import { type SortDirection } from 'types/enums'
import { type ITipPayload } from 'types/interfaces/ITypes'
import { type IGetStoryViewersUsersListResponse } from 'types/interfaces/story'

import { type NewStory, type StoriesData, type StoryFeedGroup } from '../../types/api/story'

export const uploadStory = async (post: NewStory) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/story',
        data: post
    })
    return data
}

export const getAllStories = async (creatorId?: string): Promise<StoriesData> => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: `/api/story`,
    params: creatorId ? { creator_id: creatorId } : undefined,
  })

  return data?.data
}

export const getStoryFeed = async (): Promise<StoryFeedGroup[]> => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: `/api/story/feed`,
  })

  return (data?.data?.message ?? []) as StoryFeedGroup[]
}

export const getSingleStory = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/story/${id}`
    })
    return data?.data
}

export const likeStory = async (id: string) => {
  const { data } = await axiosInstance({
    method: 'POST',
    url: `/api/like/story/${id}`
  })

  return data
}

export const unlikeStory = async (id: string) => {
  const { data } = await axiosInstance({
    method: 'DELETE',
    url: `/api/like/story/${id}`
  })

  return data
}
export const editStory = async (story: NewStory, id: string) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/story/${id}`,
        data: story
    })
    return data
}

export const sendTipToStory = async (payload: ITipPayload) => {
  const { story_id, ...data } = payload

  const response = await axiosInstance({
    method: 'POST',
    url: `/api/user/story/${story_id}/tip`,
    data
  })

  return response.data
}

export const getStoryViewersUsersList = async (
    storyId: string,
    sortDirection: SortDirection,
    page: number,
    searchTerm: string
) => {
    let apiString = `/api/views/story/${storyId}/users?sort_value=${sortDirection}&page=${page}`

    if (!isEmpty(searchTerm)) {
        apiString += `&search=${searchTerm}`
    }

    const data = await axiosInstance<IGetStoryViewersUsersListResponse>({
        method: 'GET',
        url: apiString
    })
    return data.data
}

export const getStoryLikesUsersList = async (
    storyId: string,
    sortDirection: SortDirection,
    page: number,
    searchTerm: string
) => {
    // Matches your route: Route::get('/story/{story}/users', ...)
    let apiString = `/api/like/story/${storyId}/users?sort_value=${sortDirection}&page=${page}`

    if (!isEmpty(searchTerm)) {
        apiString += `&search=${searchTerm}`
    }

    const data = await axiosInstance({
        method: 'GET',
        url: apiString
    })

    return data.data
}


export const reportStory = async ({
  storyId,
  message,
  report_type_id,
}: {
  storyId: string
  message: string
  report_type_id: number //  fix the type here
}) => {
  const { data } = await axiosInstance({
    method: 'POST',
    url: `/api/report/story/${storyId}`,
    data: {
      message,
      report_type_id, //  send correct key
    },
  })
  return data
}